import $ from 'jquery';
import {flashMessage} from "./popups";

$('#calc-button').click(function () {

    $('.bottom-panel__wrapper').slideUp('slow', function () {
        $(this).addClass('hide');
    });
    $('#header').slideUp('slow', function () {
        $(this).addClass('hide');
    });

    $('.main-page__text').fadeOut('slow', function () {
        $(this).addClass('hide');
    });

    $('.bg').fadeOut('slow', function () {
        $(this).addClass('hide');
    });
    $('._service').fadeOut('slow', function () {
        $(this).addClass('hide');
    })
    $('.bottom-copir').fadeOut('slow', function () {
        $(this).addClass('hide');
    })
    // $('.right-panel__wrapper').removeClass('hide').fadeIn('slow').addClass('show');
    $('.right-panel__wrapper').toggleClass("open");
    $('.left-panel__img').toggleClass('open-left');

});
$('#close-right').click(function () {
    const cardBack = $('.right-panel__wrapper-content__calc');

    if (!cardBack.hasClass('hide')) {
        cardBack.addClass('hide').removeClass('show');
        $('.right-panel__wrapper-content').addClass('show');
        $('.right-panel__wrapper-content').removeClass('hide');
    } else {
        // $('.right-panel__wrapper').fadeOut('slow', function () {
        $('.right-panel__wrapper').toggleClass("open");
        $('.left-panel__img').toggleClass('open-left');
        // });
        $('#header').removeClass('hide').fadeIn('slow');
        $('.bg').removeClass('hide').fadeIn('slow');
        $('.bottom-copir').removeClass('hide').fadeIn('slow');
        $('.main-page__text').removeClass('hide').fadeIn('slow');
        $('.bottom-panel__wrapper').removeClass('hide').slideDown('slow');
        $('._service').removeClass('hide').fadeIn('slow');
    }

});


$('.mobile-calculate__button').click(function () {

    $('.bottom-panel__wrapper').slideUp('slow', function () {
        $(this).addClass('hide');
    });
    $('#header').slideUp('slow', function () {
        $(this).addClass('hide');
    });

    $('.main-page__text').fadeOut('slow', function () {
        $(this).addClass('hide');
    });

    $('.bg').fadeOut('slow', function () {
        $(this).addClass('hide');
    });
    $('._service').fadeOut('slow', function () {
        $(this).addClass('hide');
    })

    // $('.right-panel__wrapper').removeClass('hide').fadeIn('slow').addClass('show');
    $('.right-panel__wrapper').toggleClass("open");
    $('.left-panel__img').toggleClass('open-left');


});
